export const CM_TOOLTIPS = {
  search: "Cerca vendor per nome, ragione sociale o ID",
  statoFilter: "Filtra per stato vendor",
  soloProblematici: "Mostra solo vendor con problemi di mapping o import",
  aggiornaLista: "Ricarica l'elenco vendor dal server",
  logs: "Apre il terminale con i log delle operazioni del servizio di importazione",
  mostraLog: "Apre il terminale con i log delle operazioni del servizio di importazione",
  importaSelezionati: "Avvia job di import per i vendor selezionati",
  importaTutti: "Avvia job di import per tutti i vendor attivi",
  importSingolo: "Avvia job di import per il vendor corrente",
  mappingCatalogo: "Vai alla pagina di manutenzione per questo vendor",
  tornaIndietro: "Torna alla lista vendor",
  ricaricaVendor: "Ricarica mapping, preview e catalogo del vendor corrente",
  importaVendor: "Avvia l'import catalogo per il vendor corrente",
  reindexVendor: "Avvia la reindicizzazione Elasticsearch dei cataloghi del vendor corrente",
  scaricaFeedRaw: "Scarica il feed dal URL configurato e salva la copia raw locale",
  caricaFeedRaw: "Carica manualmente un file feed (CSV, XML, XLSX, ...) quando il download automatico non e disponibile",
  apriUrlFeed: "Apre l'URL del feed configurato per il vendor in una nuova scheda del browser",
  salvaFeedConfig: "Salva formato feed, header e opzioni Google Drive nel profilo vendor",
  normalizza: "Converte il feed raw in tabella normalizzata usando il formato selezionato",
  normalizzaAutoMap: "Normalizza il feed e genera automaticamente il mapping colonne, salvandolo con stato auto/manual_err",
  legendaMapping: "Apre la legenda dei token disponibili per il mapping colonne",
  vediErrori: "Filtra le righe con errori dati del feed (titolo, prezzo, immagine — da correggere dal vendor)",
  vediWarnings: "Filtra le righe con soli warning (nessun errore bloccante)",
  mostraTutto: "Ripristina la preview completa del feed normalizzato",
  salvaMapping: "Salva mapping colonne, regole skip, configurazione import e aggiorna lo stato mapping nel profilo",
  importaDaNormalizzato: "Importa il catalogo usando il feed normalizzato già salvato (senza nuovo download)",
  scheduledImportEnabled: "Include o esclude questo vendor dal ciclo di import schedulato automatico",
  fieldDefaults: "SET DEF: regole per colonna DB (ALWAYS fallback o condizionali su colonna feed); overlay preview target->valore",
  aggiungiFieldDefault: "Aggiunge un valore di default per un campo mapping non presente nel feed vendor",
  rimuoviFieldDefault: "Rimuove questo valore di default dal profilo vendor",
  aggiungiSkipRule: "Aggiunge una regola per saltare righe del feed quando una colonna ha un valore specifico",
  rimuoviSkipRule: "Rimuove questa regola di skip righe",
  aggiungiAbbinamentoCategorizzazione: "Aggiunge un abbinamento albero_categorie → categoria (max 3)",
  rimuoviAbbinamentoCategorizzazione: "Rimuove questo abbinamento di categorizzazione multipla",
  eseguiAbbinamentoCategorizzazione: "Applica la categoria a tutti i prodotti con lo stesso valore albero_categorie",
  aggiungiAbbinamentoHardDelete: "Aggiunge un abbinamento colonna/valore per hard delete catalogo (max 3)",
  rimuoviAbbinamentoHardDelete: "Rimuove l'abbinamento hard delete",
  eseguiHardDelete: "Elimina fisicamente dal database tutti i cataloghi che corrispondono all'abbinamento",
  svuotaLog: "Cancella tutto l'output del terminale log",
  chiudiLog: "Chiude il popup dei log mantenendo lo storico in memoria",
  stopImport: "Richiede l'interruzione del job di import in corso",
  annullaModifica: "Chiude la modifica senza salvare",
  salvaCella: "Salva il valore modificato della cella",
  eliminaRigaNormalizzata: "Elimina la riga dal feed normalizzato e aggiorna gli errori import collegati",
  paginaPrecedente: "Pagina precedente",
  paginaSuccessiva: "Pagina successiva",
  righePerPagina: (size) => `Mostra ${size} righe per pagina`,
  chiudiLegenda: "Chiude la finestra della legenda",
  chiudiDialog: "Chiude il dialog",
  ridimensionaColonna: "Trascina per ridimensionare la larghezza della colonna",
  feedFormat: "Formato file del feed (CSV, TSV, XML, ecc.)",
  feedHeader: "Indica se la prima riga del feed contiene le intestazioni colonne",
  feedGdrive: "Scarica il feed tramite il downloader Google Drive se hostato su Drive",
  mappingFieldSelect: "Associa la colonna feed a un campo catalogo oppure skip",
  gotoLine: "Vai direttamente alla riga indicata del feed",
  gotoLineInput: "Numero riga del feed (da 1 al totale righe)",
};
